import React from 'react';
import { Feature, SelectList } from '@tencent/workbench';
import FontDropdown from '@framework/workbench/drawer/components/dropdown/font-dropdown';
import { FORM_CONFIGS } from './config';
import { getFontSizeConfigData } from '@src/framework/editor/src/js/constants/toolbar-data';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { getQuickSetFontSize } from '@src/framework/frame/components/quick-setting/quick-setting-fontsize';
import { FontSizeBoundaryVal } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/font-size';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { getTitleStyle, updateTitleStyle } from '@framework/workbench/drawer/ui/chart/common/font/util/title';
import { IChartTextProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property.interface';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { ChartElementType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';
import { ChartActionType } from '@src/slide/domain/ui-model/element-modeles/property/chart/constant';
@Feature()
export class ChartFontSizeFeature extends ChartBaseDrawerFeature {
    public getFontSize() {
        const fontSize = this.getFontSizeName();
        return `font-size-${fontSize}pt`;
    }

    public getFontSizeName() {
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return '';
        const selecetdElementType = model.selectedElement.type;
        let fontSize;
        if (selecetdElementType === ChartElementType.TITLE) {
            fontSize = this.getTitleFontSize(model);
        } else {
            const element = model.getSelectedElementProperty() as IChartTextProperty;
            if (!element) return '';
            fontSize = element?.getTextFontSize();
        }
        return Number.isNaN(Number(fontSize)) ? fontSize : Number(fontSize.toFixed(1));
    }

    public onFontSizeChange = (fontSize: string) => {
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const selecetdElementType = model.selectedElement.type;
        if (selecetdElementType === ChartElementType.TITLE) {
            return this.updateTitleFontStyle(model, ChartActionType.FONT_SIZE, fontSize);
        }
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        return element?.updateFontStyle(ChartActionType.FONT_SIZE, fontSize);
    };

    public setFontSizeIncrease = () => {
        this.setFontSizeChange(true);
    };

    public setFontSizeDecrease = () => {
        this.setFontSizeChange(false);
    };

    // eslint-disable-next-line complexity
    public setFontSizeChange = (isIncrease) => {
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return {};
        let actionType;
        let param;
        if (isIncrease) {
            actionType = ChartActionType.FONT_SIZE_UP;
            const size = getQuickSetFontSize(this.getFontSize(), actionType);
            param = {
                size,
                max: FontSizeBoundaryVal.FONT_SIZE_MAX,
            };
        } else {
            actionType = ChartActionType.FONT_SIZE_UP;
            const size = getQuickSetFontSize(this.getFontSize(), actionType);
            param = {
                size: -size,
                min: FontSizeBoundaryVal.FONT_SIZE_MIN,
            };
        }
        const selecetdElementType = model.selectedElement.type;
        if (selecetdElementType === ChartElementType.TITLE) {
            return this.updateTitleFontStyle(model, actionType, param);
        }
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        return element?.updateFontStyle(actionType, param);
    };

    public renderSelectList(isDrawer?: boolean) {
        const fontSizeData = getFontSizeConfigData();
        return (
            <SelectList
                style={{ width: 85 }}
                selected={this.getFontSize()}
                items={fontSizeData}
                onChange={this.onFontSizeChange}
            />
        );
    }

    public renderFontSize() {
        return <FontDropdown
            text={this.getFontSizeName()}
            dropContent={this.renderSelectList(true)}
            style={{ minWidth: 85, paddingLeft: 6 }}
            tooltip={FORM_CONFIGS[0].tooltip}
        />;
    }

    public shouldDisableFontSizeIncrease() {
        return this.getDisabledStatus(true, this.getFontSize());
    }

    public shouldDisableFontSizeDecrease() {
        return this.getDisabledStatus(false, this.getFontSize());
    }

    private getTitleFontSize(model: IChartModel) {
        return getTitleStyle(model, ChartActionType.FONT_SIZE);
    }

    private updateTitleFontStyle(model: IChartModel, actionType, value) {
        updateTitleStyle(model, actionType, value);
    }

    private getDisabledStatus(isAddFontSize: boolean, fontSize) {
        const num = fontSize.match(/-([\d|.]*)(\+)?pt/);
        const [, curSize, isMultiplyFonts] = num;
        const limitSize = isAddFontSize ? FontSizeBoundaryVal.FONT_SIZE_MAX : FontSizeBoundaryVal.FONT_SIZE_MIN;
        if (!isMultiplyFonts) {
            return String(curSize) === String(limitSize);
        }
        return isAddFontSize ? Number(curSize) > limitSize : Number(curSize) < limitSize;
    }
}
